'use client';

import { useEffect } from 'react';
import {
  getCookieWckAuthData,
  getCookieWckDisplayMktSID,
} from '@wconcept/wconcept-common/utils/cookie';
import { isEmpty } from '@wconcept/wconcept-common/utils/baseUtils';
import { base64Encrypt } from '@wconcept/wconcept-common/utils/cryptUtils';
import useGlobalState from '@hooks/useGlobalState';

function DatadogSetup() {
  const { datadogProperty } = useGlobalState();

  const initDatadog = async () => {
    const user = await getCookieWckAuthData();
    const isLogin = !isEmpty(user.userNo);
    const prefix = '90';
    const sessionId = await getCookieWckDisplayMktSID();
    const script = document.createElement('script');
    script.innerHTML = `
      (function(h,o,u,n,d) {
        h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
        d=o.createElement(u);d.async=1;d.src=n
        n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
      })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js','DD_RUM')
      window.DD_RUM.onReady(function() {
        if (window.DD_RUM_INITIALIZED) {
          return;
        }
        window.DD_RUM.init({
          applicationId: "${process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID}",
          clientToken: "${process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN}",
          site: 'datadoghq.com',
          version: "${process.env.NEXT_PUBLIC_BUILD_VERSION}",
          service: "${process.env.NEXT_PUBLIC_DATADOG_SERVICE_NAME}",
          env: "${process.env.NEXT_PUBLIC_DATADOG_MODE}",
          sessionSampleRate: ${datadogProperty?.rumSessionSampleRate ?? 0.5},
          sessionReplaySampleRate: ${
            datadogProperty?.rumReplaySampleRate ?? 100
          },
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          trackSessionAcrossSubdomains: true,
          defaultPrivacyLevel: 'mask-user-input',
          allowedTracingUrls: [
            {
              match: "${process.env.NEXT_PUBLIC_DISPLAY_API_BASE_URL}",
              propagatorTypes: ['tracecontext', 'datadog', 'b3', 'b3multi'],
            },
            {
              match: "${process.env.NEXT_PUBLIC_EVENT_API_BASE_URL}",
              propagatorTypes: ['tracecontext', 'datadog', 'b3', 'b3multi'],
            },
          ],
        });
        window.DD_RUM.setUser({
          id: "${
            isLogin
              ? base64Encrypt(`${prefix}${user.userNo || '0'}`)
              : base64Encrypt(`${prefix}0`)
          }",
          sessionid: "${
            isLogin
              ? base64Encrypt(prefix + sessionId)
              : base64Encrypt(prefix + sessionId)
          }",
        })
        window.DD_RUM_INITIALIZED = true;
      });
    `;
    document.head.appendChild(script);
  };

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      !('DD_RUM' in window) &&
      !window.DD_RUM_INITIALIZED
    ) {
      initDatadog();
    }
  }, [datadogProperty]);

  return null;
}

export default DatadogSetup;
